import PropTypes from "prop-types";

import React from "react";

// import { withRouter, matchPath } from "react-router";

import Link from "../../Link";
// ^^ A Link element for our custom history router.

import SEO from "../../../../../global-components/seo";

import * as ROUTES from "../../../constants/routes.js";

import SubmitSpinner from "./SubmitSpinner";

import "./style.scss";

class SubmitButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      needsUpload: false,
    };

    this.vars = {
      //
    };
  }

  componentDidMount() {
    // this.timerID = setInterval(() => this.tick(), 1000);

    this.init();
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    /* if (this.props.currentRoute !== prevProps.currentRoute) {
            Z.loadPage();
        } */
  }

  init = () => {
    const Z = this;
  };

  submitForm = () => {
    const Z = this;

    var needsUpload = false;
    for (var fieldName in Z.props.fieldTypes) {
      const fieldType = Z.props.fieldTypes[fieldName];
      if (fieldType == "UploadButton") needsUpload = true;
    }
    Z.setState({ needsUpload }, () => {
      var isComplete = Z.props.validateForm();
      // DEMO:
      // var isComplete = true;

      if (isComplete == true) {
        if (Z.props.action != null) Z.props.action();
      }
    });
  };

  render() {
    var Z = this;

    var errorsExist = Object.keys(Z.props.formErrors).length > 0;

    var submitText = Z.props.title ?? "Submit";
    if (Z.props.submitting) {
      if (Z.state.needsUpload) {
        submitText = (
          <>
            Uploading and submitting <SubmitSpinner />
          </>
        );
      } else {
        submitText = (
          <>
            Submitting <SubmitSpinner />
          </>
        );
      }
    }

    return (
      <div className={`SubmitButton ${errorsExist ? "error" : ""} ${Z.props.submitting ? "submitting" : ""} ${Z.state.needsUpload ? "needsUpload" : ""}`}>
        <button type="button" disabled={Z.props.submitting ? "disabled" : null} onClick={Z.submitForm}>
          {submitText}
        </button>
        <div className="error-message">Please complete the required fields.</div>
      </div>
    );
  }
}

SubmitButton.propTypes = {
  title: PropTypes.string,
  action: PropTypes.func,
  submitting: PropTypes.bool,
  formValues: PropTypes.object,
  fieldTypes: PropTypes.object,
  validateForm: PropTypes.func,
  formErrors: PropTypes.object,
};

export default SubmitButton;
